<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb65></breadcrumb65>

          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-5 col-lg-6 col-xl-7 text-center" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <div class="card ml-4" id="shedule_container" style="border: none;">
                    <div class="mb-4"
                      style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                      <div class="radio">
                        <span>
                          <div class="form-group">
                            <input type="checkbox" id="showcharges" name="showcharges"
                              v-model="show_charges_at_portal" />
                            <label for="showcharges">
                              Show Charges at Portal</label>
                          </div>
                        </span>
                      </div>
                      <div class="buttons" style="display: flex;">
                        <a href="#" data-toggle="modal" data-target="#addhospital" class="btn btn-primary btn-sm mr-1"
                          tabindex="0">Add Therapy</a>
                        <a href="#" data-toggle="modal" data-target="#addModality" class="btn btn-primary btn-sm"
                          tabindex="0">Add Modality</a>
                      </div>
                    </div>
                    <div class="service-group" id="manualTherapyGroup">
                      <div v-for="(row, index) in manual_therapy_charges" :key="index" class="service-row">
                        <label>Manual Therapy</label>
                        <input type="text" v-model="row.therapy" placeholder="Manual Therapy">
                        <input type="text" v-model="row.charges" placeholder="Charges">
                        <input type="text" v-model="row.discount_offered" placeholder="Discount offered">
                        <button type="button" class="add-button" @click="addManualTherapyRow">+</button>
                        <button v-if="index > 0" type="button" class="remove-button"
                          @click="removeManualTherapyRow(index)">-</button>
                      </div>
                    </div>

                    <div class="service-group" id="modalityGroup">
                      <div v-for="(row, index) in modality_charges" :key="index" class="service-row">
                        <label>Modality</label>
                        <select v-model="row.modality">
                          <option value="">Select</option>
                          <option v-for="modality in modalityOptions" :key="modality.id" :value="modality.name">
                            {{ modality.name }}
                          </option>
                        </select>
                        <input type="text" v-model="row.charges" placeholder="Charges">
                        <input type="text" v-model="row.discount_offered" placeholder="Discount offered">
                        <button type="button" class="add-button" @click="addModalityRow">+</button>
                        <button v-if="index > 0" type="button" class="remove-button"
                          @click="removeModalityRow(index)">-</button>
                      </div>
                    </div>

                    <!-- Physiotherapy Packages Group -->
                    <div class="service-group" id="physioPackagesGroup">
                      <div v-for="(row, index) in physiotherapy_charges" :key="index" class="service-row">
                        <label>Physiotherapy Packages</label>
                        <select v-model="row.days">
                          <option value="">No. of days</option>
                          <option value="5-days">5 Days</option>
                          <option value="10-days">10 Days</option>
                          <option value="15-days">15 Days</option>
                        </select>
                        <input type="text" v-model="row.charges" placeholder="Charges">
                        <input type="text" v-model="row.discount_offered" placeholder="Discount offered">
                        <button type="button" class="add-button" @click="addPhysioPackageRow">+</button>
                        <button v-if="index > 0" type="button" class="remove-button"
                          @click="removePhysioPackageRow(index)">-</button>
                      </div>
                    </div>

                    <div class="submit-section">
                      <button class="btn btn-primary submit-btn btn-sm" @click="submitDoctorCharges">Submit
                        Charges</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="addhospital">
        <div class="modal-dialog modal-dialog-centered modal-md doctor-profile">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Therapy</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">

                </div>
                <div class="submit-section" style="text-align: left">
                  <button class="btn btn-primary submit-btn  mb-2 ml-4" data-dismiss="modal" aria-label="Close">
                    Add Therapy
                  </button>
                </div>
                <!-- </form> -->
                <!-- /Profile Settings Form -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- add modality modal -->
      <div class="modal fade custom-modal show" id="addModality">
        <div class="modal-dialog modal-dialog-centered modal-md doctor-profile">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Modality</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">

                </div>
                <div class="submit-section" style="text-align: left">
                  <button class="btn btn-primary submit-btn  mb-2 ml-4" data-dismiss="modal" aria-label="Close">
                    Add Modality
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonApi from '../../../services/CommonApi';  // Import CommonApi if not already done
import { mapState } from "vuex";
export default {
  data() {
  return {
    showspinner: false,
    name: this.user_id,
    show_charges_at_portal: false,
    manual_therapy_charges: [
      { therapy: '', charges: '', discount_offered: '' } // Default entry
    ],
    modality_charges: [
      { modality: '', charges: '', discount_offered: '' } // Default entry
    ],
    physiotherapy_charges: [
      { days: '', charges: '', discount_offered: '' } // Default entry
    ],
    modalityOptions: []  // Fetched modality options will be stored here
  };
},

  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    })
  },
  methods: {
    // Method to fetch modalities using CommonApi.get_data
    async fetchModalities() {
      try {
        const response = await CommonApi.get_data("sahaj.api.get_modality");
        if (response && response.message) {
          this.modalityOptions = response.data;
        }
      } catch (error) {
        console.error("Failed to fetch modalities:", error);
      }
    },
    addManualTherapyRow() {
      this.manual_therapy_charges.push({ therapy: '', charges: '', discount_offered: '' });
    },
    removeManualTherapyRow(index) {
      this.manual_therapy_charges.splice(index, 1);
    },
    addModalityRow() {
      this.modality_charges.push({ modality: '', charges: '', discount_offered: '' });
    },
    removeModalityRow(index) {
      this.modality_charges.splice(index, 1);
    },
    addPhysioPackageRow() {
      this.physiotherapy_charges.push({ days: '', charges: '', discount_offered: '' });
    },
    removePhysioPackageRow(index) {
      this.physiotherapy_charges.splice(index, 1);
    },

    async submitDoctorCharges() {
      try {
        this.showspinner = true;
        // Construct the payload object as per the given format
        const payload = {
          doctor_name: this.user_id,  // Assume `name` is the doctor name
          show_charges_at_portal: this.show_charges_at_portal,
          modality_charges: this.modality_charges.map(row => ({
            modality: row.modality,
            charges: parseInt(row.charges, 10) || 0,
            discount_offered: parseInt(row.discount_offered, 10) || 0
          })),
          physiotherapy_charges: this.physiotherapy_charges.map(row => ({
            days: row.days,  // Convert days to integer
            charges: parseInt(row.charges, 10) || 0,
            discount_offered: parseInt(row.discount_offered, 10) || 0
          })),
          manual_therapy_charges: this.manual_therapy_charges.map(row => ({
            therapy: row.therapy,
            charges: parseInt(row.charges, 10) || 0,
            discount_offered: parseInt(row.discount_offered, 10) || 0
          }))
        };

        // Send the constructed payload to the API
        const response = await CommonApi.post_data("sahaj.api.update_doctor_charges", payload);
        if (response) {
          console.log("d", response);
        } else {
          alert("Failed to update charges. Please try again.");
        }
      } catch (error) {
        console.error("Error while submitting charges:", error);
        alert("An error occurred while updating charges.");
      } finally {
        this.showspinner = false;  // Hide loader after API call is complete
      }
    },


    get_doctor_details() {
  const params = new URLSearchParams();
  params.append("name", this.user_id);
  CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
    if (res && res.data && res.status_code === 200) {
      this.showspinner = false;
      this.show_charges_at_portal = res.data.show_charges_at_portal;

      // Set charges or fallback to default empty array
      this.modality_charges = res.data.modality_charges.length
        ? res.data.modality_charges.map((item) => ({
            modality: item.modality,
            charges: item.charges,
            discount_offered: item.discount_offered,
          }))
        : [{ modality: '', charges: '', discount_offered: '' }];

      this.manual_therapy_charges = res.data.custom_manual_therapy_charges.length
        ? res.data.custom_manual_therapy_charges.map((item) => ({
            therapy: item.therapy,
            charges: item.charges,
            discount_offered: item.discount_offered,
          }))
        : [{ therapy: '', charges: '', discount_offered: '' }];

      this.physiotherapy_charges = res.data.custom_physiotherapy_charges.length
        ? res.data.custom_physiotherapy_charges.map((item) => ({
            days: item.days,
            charges: item.charges,
            discount_offered: item.discount_offered,
          }))
        : [{ days: '', charges: '', discount_offered: '' }];
    }
  });
},


  },
  // Fetch modalities when the component is mounted
  mounted() {
    this.fetchModalities();
    this.get_doctor_details();
  }
};
</script>



<style scoped>
h2 {
  color: #1a3e92;
  font-size: 24px;
  display: flex;
  align-items: center;
}

h2:before {
  content: "▶️";
  font-size: 24px;
  margin-right: 10px;
}

.service-group {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;
}

.service-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.service-row label {
  width: 150px;
  font-size: 14px;
  margin-right: 10px;
  font-weight: bold;
}

.service-row input,
.service-row select {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 150px;
  margin-right: 10px;
}

.add-button,
.remove-button {
  background-color: #1a3e92;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 18px;
  margin-left: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.remove-button {
  background-color: red;
}

.add-button:hover,
.remove-button:hover {
  background-color: #14357d;
}

.remove-button:hover {
  background-color: darkred;
}

/* Responsive Design */
@media (max-width: 768px) {
  .service-row {
    flex-wrap: wrap;
  }

  .service-row input,
  .service-row select {
    width: 100%;
    margin-bottom: 10px;
  }

  .add-button,
  .remove-button {
    margin-left: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/MyServices.vue